import { useMutation } from 'react-query';
import { httpService } from '../../../../services/http.service';
import { BASE_URL } from '../../../../constants/endpoints';

interface IProps {
    customerId: string;
    invoiceId: string;
    reminderTypes: string[]
}

export const useCreateInvoice = () => useMutation('CreateInvoice', async ({ customerId, invoiceId, reminderTypes }: IProps) => {
  const res = await httpService.post(
    `${BASE_URL}/api/v2/user/${customerId}/invoice/${invoiceId}/markAsOutstanding`,
    {
      invoiceReminderTypes: reminderTypes,
    },
  );
  return res.data;
}, { retry: 0 });
